// Haptic feedback for scanning.
//
// navigator.vibrate works on Android Chrome but is UNSUPPORTED on iOS Safari
// (Apple blocks the Vibration API entirely), where it is a silent no-op. So on
// iPhone the audible "ting" + on-screen toast are the real confirmation; the
// vibration is an Android-only bonus.

const SUCCESS_PATTERN = 40
const ERROR_PATTERN = [60, 40, 60]

/**
 * Trigger a vibration. Injectable nav for testing; defaults to the global
 * navigator. Returns whether a vibration was actually dispatched.
 */
export function vibrate(
    pattern: number | number[],
    nav: Pick<Navigator, 'vibrate'> | undefined = typeof navigator !==
    'undefined'
        ? navigator
        : undefined,
): boolean {
    if (!nav || typeof nav.vibrate !== 'function') return false
    try {
        return nav.vibrate(pattern)
    } catch {
        return false
    }
}

/** Short tap — a package was accepted. */
export function vibrateSuccess(): void {
    vibrate(SUCCESS_PATTERN)
}

/** Triple buzz — distinct from success, signals a rejected/failed scan. */
export function vibrateError(): void {
    vibrate(ERROR_PATTERN)
}
